import styled, { keyframes } from "styled-components";
import { handleStatusColors } from "./utils";

export const statusUpdate = keyframes`
  25% {
    transform: scale(1.08);
  }
`;
export const StatusWindowWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e8e8eb;
  font-family: Rubik;
  text-align: left;
  padding: 16px;
`;
export const StatusTitle = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.04em;
  color: #536586;
  margin-bottom: 12px;
  text-transform: uppercase;
`;
export const StatusBox = styled.div`
  animation: ${statusUpdate} 0.8s ease-in-out;
  display: flex;
  padding: 12px;
  align-items: center;
  flex-direction: column;
  background-color: ${({ status }) => handleStatusColors(status).backgroundColor};
  border-radius: 8px;
  border: 1px solid ${({ status }) => handleStatusColors(status).backgroundColor};
`;
export const StatusHeaderSection = styled.div`
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  width: 100%;
`;
export const StatusHeaderTitle = styled.span`
  color: ${({ status }) => handleStatusColors(status).color};
  opacity: 0.8;
`;
export const StatusHeaderIcon = styled.span`
  width: 32px;
  height: 32px;
  margin-right: 12px;
  img {
    width: 100%;
  }
`;
export const StatusBody = styled.span`
  color: #1e1f46;
  opacity: 0.5;
`;
